import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static values = {
    targetId: String,
  };

  connect() {
    var target = this.targetIdValue;
    var targetModal = document.querySelector(target);
    $(target).fadeIn(300);
    targetModal.showModal();
    targetModal.classList.add("is-open");
    this.htmlFix();
  }
}
